import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import axios from 'axios';
import { API_URL } from "../../Api/config";
import { IoClose } from "react-icons/io5";

function FormContact(props) {

    const [fName, setFName] = useState('');
    const [lName, setLName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [descripation, setDescripation] = useState('');
    const [validated, setValidated] = useState(false);
    const [apicall, setApicall] = useState(false);
    const [serverSideError, setServerSideError] = useState(null);


    const handleSubmit = event => {
        setApicall(true);
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setApicall(false);
        } else {
            event.preventDefault();

            axios.post(API_URL + 'contact/submit', {
                firstName: fName,
                lastName: lName,
                phoneNumber: phone,
                email: email,
                description: descripation,
                subject: props.subject
            }
                , {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    console.log("response", response);
                    handleShow();
                    setFName('');
                    setLName('');
                    setPhone('');
                    setEmail('');
                    setDescripation('');
                    setServerSideError(null);
                    // do something with response, like setting a success message state
                })
                .catch(error => {
                    console.log("error", error);
                    setServerSideError(error.response.data);
                    // handle the error
                }).finally(() => {
                    setApicall(false);
                    setValidated(false);
                });
        }
        setValidated(true);
    };



    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>

            <Modal
                show={show}
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <div className="logo-modal">
                            <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                        </div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className='modal-image'>
                        <img src={require('../../assets/images/forewardFormSubmit.png')} alt="logo" />
                    </div>
                    <h3 className="text-center mb-4">
                        Your message is sent!
                    </h3>
                    <p className="text-center mb-0">
                        Our staff will be in contact shortly to answer any questions and get you sorted.
                    </p>
                </Modal.Body>
            </Modal>



            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <div className="row gx-2">
                    <div className="col-md-6 form-group" controlid="validationCustom01">
                        <input type="text" name="f-name" className="form-control" placeholder="First name" value={fName} onChange={e => setFName(e.target.value)} required />
                        <Form.Control.Feedback type="invalid">
                            Please enter a first name.
                        </Form.Control.Feedback>
                    </div>
                    <div className="col-md-6 form-group" controlid="validationCustom02">
                        <input type="text" name="l-name" className="form-control" placeholder="Last name" value={lName} onChange={e => setLName(e.target.value)} required />
                        <Form.Control.Feedback type="invalid">
                            Please enter a last name.
                        </Form.Control.Feedback>
                    </div>
                    <div className="col-md-12 form-group" controlid="validationCustom03">
                        <input type="tel" name="name" pattern="[0-9]{8,}" title="Please enter a 8-digit phone number." className="form-control" placeholder="Phone" value={phone} onChange={e => setPhone(
                            () => {
                                if (typeof e.target.value === 'number') {
                                    setPhone(e.target.value)
                                } else {
                                    setPhone(e.target.value.replace(/[^0-9]/g, ''))
                                }
                            }
                        )} required />
                        <Form.Control.Feedback type="invalid">
                            Please enter a 8-digit phone number.
                        </Form.Control.Feedback>
                        {serverSideError && (serverSideError.data).map((error, index) => (
                            error.field === 'phone_number' ? (
                                <div className="text-danger" key={index}>{error.detail}</div>
                            ) : null
                        ))}
                    </div>
                    <div className="col-md-12 form-group" controlid="validationCustom04">
                        <input type="email" className="form-control" name="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
                        <Form.Control.Feedback type="invalid">
                            Please choose a email.
                        </Form.Control.Feedback>
                        {serverSideError && (serverSideError.data).map((error, index) => (
                            error.field === 'email' ? (
                                <div className="text-danger" key={index}>{error.detail}</div>
                            ) : null
                        ))}
                    </div>
                    <div className="col-md-12 form-group">
                        <textarea className="form-control" name="message" placeholder="Let us now what you need!" value={descripation} onChange={e => setDescripation(e.target.value)} rows={10} required></textarea>
                    </div>
                    <div className="col-md-12 text-center">
                        <button className="btn btn-dark btn-block form-btn" type="submit">
                            {
                                apicall ? <Spinner animation="border" className="border-white" /> : <span>Consult our staff</span>
                            }
                        </button>
                    </div>
                </div>
            </Form>
        </>
    );
}

export default FormContact;